import { useState } from "react";
import { faqItems } from "@/mocks/faq";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>("faq-001");

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-accent-500 text-sm font-medium mb-3">
            <i className="ri-question-answer-line"></i>
            <span>常见问题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            用户常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            关于海角原创资源下载及使用的常见疑问，我们为您一一解答
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200 overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-4 text-left cursor-pointer hover:bg-background-100 transition-colors duration-200"
                onClick={() => setOpenId(openId === item.id ? null : item.id)}
                aria-expanded={openId === item.id}
              >
                <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </span>
                <i className={`${openId === item.id ? "ri-subtract-line text-primary-500" : "ri-add-line text-foreground-500"} text-lg flex-shrink-0 transition-all duration-200`}></i>
              </button>
              {openId === item.id && (
                <div className="px-6 pb-5">
                  <p className="text-foreground-600 text-sm leading-relaxed border-t border-background-200 pt-4">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}